export const croatianTranslations: Record<string, string> = {
  // Navigation
  'nav.home': 'Naslovnica',
  'nav.shop': 'Proizvodi',
  'nav.about': 'O nama',
  'nav.contact': 'Kontakt',
  'nav.blog': 'Blog',
  'nav.trackOrder': 'Praćenje narudžbe',

  // Hero
  'hero.badge.pdrn': 'PDRN tehnologija',
  'hero.badge.glassSkin': 'Glass Skin efekt',
  'hero.badge.korean': 'Korejska inovacija',
  'hero.title': 'PDRN njega - korejski DNA lososa',
  'hero.subtitle': 'Transformirajte svoju kozu s klinicki dokazanim PDRN serumom, platnenim maskama i kapsuliranom kremom. Postignite Glass Skin efekt s premium PDRN proizvodima za njegu koze na bazi DNA lososa.',
  'hero.cta': 'Otkrijte kolekciju',
  'hero.ctaSurvey': 'Besplatna analiza koze',
  'hero.socialProof': 'Omiljeno kod 10.000+ ljubiteljica njege koze',
  'survey.bubbleTooltip': 'Personalizirana rutina + 10% popusta',

  // Products
  'products.title': 'Nasa kolekcija',
  'products.subtitle': 'Premium korejska njega s PDRN tehnologijom',
  'products.addToCart': 'Dodaj u kosaricu',
  'products.buyNow': 'Kupi odmah',
  'products.soldOut': 'Rasprodano',
  'products.save': 'Akcija',
  'products.viewDetails': 'Detalji',
  'products.noProducts': 'Trenutno nema dostupnih proizvoda',
  'products.selectSize': 'Odaberite velicinu',
  'products.quantity': 'Kolicina',
  'products.inStock': 'Na zalihi',
  'products.outOfStock': 'Rasprodano',

  // Upsell
  'upsell.title': 'Upotpunite svoju rutinu',
  'upsell.savings': 'Ustedite s kompletnim setom',
  'upsell.cta': 'Nadogradite na kompletni set',
  'upsell.includes': 'Kompletna rutina njege u jednom paketu',
  'upsell.badge': 'Upotpunite svoju rutinu',
  'upsell.saveBadge': 'Ustedite {amount}!',
  'upsell.whyBundle': 'Zasto odabrati kompletni set?',
  'upsell.whyBundleDesc': 'Svaki korak nadograduje prethodni za maksimalne rezultate',
  'upsell.includesSerum': 'Serum za sjaj',
  'upsell.includesCream': 'Pametna kapsulirana krema',
  'upsell.includesMasks': 'Pakiranje od 10 maski',
  'upsell.separatelyPrice': 'Pojedinacno: {amount}',
  'upsell.serumTooltip': 'Lagani PDRN serum koji potice proizvodnju kolagena, izgladzuje bore i daje trenutni Glass Skin sjaj.',
  'upsell.creamTooltip': 'Inovativna kapsulirana formula s PDRN-om, 5% niacinamidom i hidroliziranim kolagenom za duboku hidrataciju i cvrstinu.',
  'upsell.masksTooltip': '10 platnenih maski natopljenih koncentriranim PDRN serumom za intenzivni tretman koji daje trenutni Glass Skin efekt.',

  // Cart
  'cart.title': 'Kosarica',
  'cart.empty': 'Vasa kosarica je prazna',
  'cart.itemCount': '{count} artikala u kosarici',
  'cart.total': 'Ukupno',
  'cart.checkout': 'Na blagajnu',
  'cart.continueShopping': 'Nastavite kupovinu',
  'cart.addedToCart': 'Dodano u kosaricu!',
  'cart.couponPlaceholder': 'Kod za popust',
  'cart.applyCoupon': 'Primijeni',
  'cart.couponApplied': 'Popust je primijenjen!',
  'cart.couponError': 'Nevazeci kod',
  'cart.removeCoupon': 'Ukloni',
  'cart.freeShippingUnlocked': 'Ostvarili ste besplatnu dostavu!',
  'cart.freeShippingRemaining': 'Dodajte jos {amount} za besplatnu dostavu',
  'cart.freeShippingThreshold': 'Besplatna dostava za narudzbe iznad {amount}',
  'cart.completeRoutine': 'Upotpuni svoju rutinu',
  'cart.bundleSave': 'Ustedi {percent}%',
  'cart.quickAdd': 'Dodaj',

  'promo.b2g1': '🎁 Dodaj 3 proizvoda u košaricu — 1 je BESPLATAN!',
  'promo.b2g1Cart': '🎁 Akcija 2+1 aktivirana! Za svaka 3 proizvoda 1 je BESPLATAN!',
  'promo.b2g1CartHint': 'Dodaj još {count} za BESPLATAN proizvod! (potrebna 3 proizvoda)',
  'promo.b2g1Saving': 'Uštedi {amount} — najjeftiniji proizvod je BESPLATAN!',
  'promo.freeItem': '🎁 BESPLATNO u akciji',

  // About
  'about.title': 'O nama',
  'about.subtitle': 'Znanost iza korejske ljepote',
  'about.pdrnTitle': 'Znanost PDRN njege',
  'about.pdrnDescription': 'PDRN (polidezoksiribonukleotid) se dobiva iz DNA lososa - revolucionarni sastojak u korejskoj njezi koze. Nasi PDRN proizvodi poticu stanicnu regeneraciju za savrsen Glass Skin efekt.',
  'about.glassSkinDesc': 'Postignite zeljeni korejski Glass Skin efekt s trenutnim sjajem.',
  'about.hydrationDesc': 'Duboka hidratacija koja traje cijeli dan, s klinicki dokazanim ocuvanjem vlage.',
  'about.antiAgingDesc': 'Prirodno potaknite proizvodnju kolagena za cvrscu i mladoliiju kozu.',

  // Footer
  'footer.copyright': '\u00a9 2026 PDRN SKIN. Sva prava pridrzana.',
  'footer.freeShipping': 'Besplatna dostava iznad {amount} (Hrvatska)',
  'footer.securePayment': 'Sigurno placanje',
  'footer.support': 'Podrska 24/7',
  'footer.description': 'Premium korejska njega s revolucionarnom PDRN tehnologijom. Dozivite Glass Skin efekt s nasim znanstveno utemeljenim proizvodima.',
  'footer.sheetMasks': 'Platnene maske',
  'footer.serum': 'Serum',
  'footer.cream': 'Krema',
  'footer.bundle': 'Kompletni set',
  'footer.faq': 'Cesta pitanja',
  'footer.shippingReturns': 'Dostava i povrati',
  'footer.privacyPolicy': 'Politika privatnosti',
  'footer.termsOfService': 'Uvjeti koristenja',
  'footer.returnPolicy': 'Politika povrata',
  'footer.contactSupport': 'Tu smo za vas — pitanja, status narudžbe, problemi ili pomoć pri kupnji. Kontaktirajte našu korisničku službu na',

  // Common
  'common.verified': 'Verificirano',
  'common.before': 'Prije',
  'common.after': 'Poslije',
  'common.loading': 'Ucitavanje...',
  'common.error': 'Doslo je do greske',
  'common.noPhotoShared': 'Kupac nije prilozia fotografiju',

  // Media
  'media.videoPlaceholder': 'Rezervirano mjesto za video',
  'media.gifPlaceholder': 'Rezervirano mjesto za GIF',
  'media.imagePlaceholder': 'Rezervirano mjesto za sliku',

  // Features
  'feature.hydration': '+100% hidratacija',
  'feature.glassSkin': 'Glass Skin efekt',
  'feature.antiAging': 'Anti-aging',
  'feature.collagen': 'Poticanje kolagena',
  'feature.brightening': 'Posvjetljivanje',

  // Product
  'product.howToUse': 'Nacin koristenja',
  'product.ingredients': 'Kljucni sastojci',
  'product.reviews': 'Recenzije kupaca',
  'product.results': 'Stvarni rezultati',
  'product.realResults': 'Stvarni rezultati',
  'product.beforeAfter': 'Prije i poslije',
  'product.faqTitle': 'Pitanja i odgovori',
  'product.mediaGallery': 'Medijska galerija',
  'product.freeShipping': 'Besplatna dostava od {amount}',
  'product.secureCheckout': 'Sigurno placanje',
  'product.returns': 'Povrat unutar 7 dana',
  'product.koreanFormula': 'Korejska formula',
  'product.premiumIngredients': 'Premium sastojci',
  'product.backHome': 'Povratak na naslovnicu',
  'product.notFound': 'Proizvod nije pronaden',
  'product.bestValue': 'Najbolja vrijednost',
  'product.bestseller': 'Najprodavanije',
  'product.reviewCount': '({count} recenzija)',
  'product.crueltyFree': 'Bez testiranja na zivotinjama',
  'product.youMayAlsoLike': 'Moglo bi vam se svidjeti',
  'product.completeRoutine': 'Upotpunite svoju rutinu njege',
  'product.moneyBack': 'Povrat novca unutar 7 dana',
  'product.dermatologistTested': 'Dermatoloski testirano',
  'product.payWith': 'Sigurno placanje putem',
  'product.specsTitle': 'Detalji proizvoda',
  'product.specsVolume': 'Velicina',
  'product.specsSkinType': 'Tip koze',
  'product.specsTested': 'Testiranja',
  'product.specsClinicallyTested': 'Klinicki testirano',
  'product.specsShelfLife': 'Rok trajanja',
  'product.specsFreeOf': 'Bez parabena, sulfata i ftalata',
  'product.satisfactionGuarantee': 'Jamstvo 100% zadovoljstva',
  'product.satisfactionDesc': 'Isprobajte bez rizika uz nase jamstvo povrata novca unutar 7 dana',

  // Before/After
  'beforeAfter.customer1': 'Ana',
  'beforeAfter.customer2': 'Petra',
  'beforeAfter.customer3': 'Ivana',
  'beforeAfter.weeks3': '3 tjedna koristenja',
  'beforeAfter.weeks8': '8 tjedana koristenja',
  'beforeAfter.weeks12': '12 tjedana koristenja',

  // Mobile Cart
  'mobileCart.findRoutine': 'Pronadite svoju rutinu',

  // Survey
  'survey.buttonText': 'Pronadite svoju rutinu',
  'survey.title': 'Analiza koze',
  'survey.subtitle': 'Odgovorite na nekoliko kratkih pitanja i pronacu vam savrenu rutinu',
  'survey.question': 'Pitanje',
  'survey.back': 'Natrag',
  'survey.next': 'Dalje',
  'survey.getResults': 'Rezultati',
  'survey.resultsTitle': 'Rutina koju sam odabrala za vas',
  'survey.resultsSubtitle': 'Na temelju vasih odgovora, evo sto preporucujem',
  'survey.yourProfile': 'Profil vase koze',
  'survey.recommended': 'Preporuceno za vas',
  'survey.bundleNote': 'Za najbolje rezultate preporucujem kompletni set',
  'survey.howToUse': 'Rutina koju sam odabrala za vas',
  'survey.morning': 'Jutro',
  'survey.evening': 'Vecer',
  'survey.expectedResults': 'Ocekivani rezultati',
  'survey.week': 'Tjedan',
  'survey.weeks': 'Tjedana',
  'survey.personalTips': 'Moji savjeti za vas',
  'survey.retake': 'Ispunite ponovo',
  'survey.shopNow': 'Kupite odmah',
  'survey.errorTooMany': 'Previse zahtjeva. Pokusajte ponovno kasnije.',
  'survey.errorGeneric': 'Nesto je poslo po krivu. Pokusajte ponovno.',
  'survey.yourPersonalizedRoutine': 'Rutina koju sam odabrala za vas',
  'survey.treatmentPlan': 'Preporuceno trajanje tretmana',
  'survey.addRoutineToCart': 'Dodajte rutinu u kosaricu',
  'survey.satisfactionGuarantee': 'Jamstvo 100% zadovoljstva',
  'survey.maybeLater': 'Mozda kasnije',
  'survey.continueSurvey': 'Nastavite s upitnikom',
  'survey.addedToCart': 'Proizvodi su dodani u kosaricu!',
  'survey.personalizedRoutine': 'Vasa personalizirana rutina je spremna',
  'survey.errorAddingToCart': 'Greska pri dodavanju u kosaricu',
  'survey.exclusiveDiscount': '10% ekskluzivnog popusta za vas!',
  'survey.couponCopied': 'Kupon kod je kopiran!',
  'survey.useAtCheckout': 'Koristite kod SURVEY10 na blagajni za 10% popusta',
  'survey.bestDeal': 'Najbolja ponuda koju sam pronasla za vas!',
  'survey.separatePrice': 'Pojedinacno',
  'survey.yourPrice': 'Vasa cijena',
  'survey.youSave': 'Ustedjujete',
  'survey.upgradeOption': 'Zelite jos bolje rezultate?',
  'survey.upgradeToBundle': 'Nadogradnja na kompletnu rutinu',
  'survey.upgradeSave': 'Ustedite {amount} s kompletnim setom',
  'survey.addSingleToCart': 'Dodajte u kosaricu',

  // Survey loading messages
  'survey.loading.analyzing': 'Analiziram vas profil koze...',
  'survey.loading.planning': 'Planiram personalizirani tretman...',
  'survey.loading.matching': 'Pronalazim savrsene proizvode za vas...',
  'survey.loading.finalizing': 'Gotovo je spremno...',

  // Survey questions
  'survey.q1.question': 'Koji je vas tip koze?',
  'survey.q1.dry': 'Suha - koza mi se cesto osjeca zategnuto',
  'survey.q1.oily': 'Masna - sjajna, posebno na celu i nosu',
  'survey.q1.combination': 'Mjesovita - masno celo i nos, suhi obrazi',
  'survey.q1.normal': 'Normalna - uravnotezena, bez znacajnih problema',
  'survey.q2.question': 'Sto vas najvise muci kod vase koze?',
  'survey.q2.aging': 'Bore i linije izraza',
  'survey.q2.acne': 'Akne i pristici',
  'survey.q2.dullness': 'Tupa koza i nejednak ten',
  'survey.q2.hyperpigmentation': 'Tamne mrlje i hiperpigmentacija',
  'survey.q3.question': 'Koliko je vasa koza osjetljiva?',
  'survey.q3.very': 'Vrlo osjetljiva - reagira na vecinu proizvoda',
  'survey.q3.somewhat': 'Umjereno osjetljiva - povremene reakcije',
  'survey.q3.not': 'Nije osjetljiva - podnosi vecinu proizvoda',
  'survey.q4.question': 'Koliko je vasa koza hidratizirana?',
  'survey.q4.veryDry': 'Vrlo suha - stalno treba hidrataciju',
  'survey.q4.somewhatDry': 'Pomalo suha - redovito treba hidrataciju',
  'survey.q4.balanced': 'Uravnotezena - ni suha ni masna',
  'survey.q4.wellHydrated': 'Dobro hidratizirana - cvrsta i zdrava',
  'survey.q5.question': 'Koji je vas dobni raspon?',
  'survey.q5.under25': 'Ispod 25',
  'survey.q5.25to35': '25-35',
  'survey.q5.35to45': '35-45',
  'survey.q5.over45': 'Iznad 45',
  'survey.q6.question': 'Kako biste opisali svoju trenutnu rutinu njege?',
  'survey.q6.minimal': 'Minimalna - samo ciscenje i hidratacija',
  'survey.q6.basic': 'Osnovna - ciscenje, toner, hidratacija',
  'survey.q6.moderate': 'Umjerena - ukljucuje serume i tretmane',
  'survey.q6.extensive': 'Opsezna - potpuna korejska rutina njege',
  'survey.q7.question': 'Kako biste opisali teksturu svoje koze?',
  'survey.q7.smooth': 'Glatka i ujednacena',
  'survey.q7.rough': 'Gruba i teksturirana',
  'survey.q7.uneven': 'Nejednaka s ponekom kvrzom',
  'survey.q7.bumpy': 'Kvrgava s vidljivim porama',
  'survey.q8.question': 'Koji je vas glavni cilj u njezi koze?',
  'survey.q8.glow': 'Postici korejski efekt sjaja',
  'survey.q8.antiAging': 'Smanjiti znakove starenja',
  'survey.q8.hydration': 'Duboka hidratacija',
  'survey.q8.all': 'Sve navedeno',

  // Trust Strip
  'trust.clinicallyTested': 'Klinicki testirano',
  'trust.happyCustomers': '10.000+ zadovoljnih kupaca',
  'trust.labFormula': 'Korejska laboratorijska formula',
  'trust.moneyBack': 'Povrat novca unutar 7 dana',

  // Science
  'science.title': 'PDRN iz DNA lososa - znanstveno dokazano',
  'science.subtitle': 'PDRN je klinicki dokazan s recenziranim istrazivanjima',
  'science.citation1': '"PDRN potice cijeljenje rana i regeneraciju tkiva aktivacijom adenozinskog receptora A2A."',
  'science.source1': '- Journal of Cosmetic Dermatology, 2020',
  'science.citation2': '"PDRN podrijetlom iz lososa znacajno poboljsava hidrataciju, elasticnost i smanjuje dubinu bora u klinickim ispitivanjima."',
  'science.source2': '- International Journal of Molecular Sciences, 2021',

  // Science Inside
  'scienceInside.title': 'Znanost iznutra',
  'scienceInside.subtitle': 'Zasto ova formula djeluje - dva mocna pokretaca u jednom serumu',
  'scienceInside.peptides.title': 'Peptidi - inzenjeri',
  'scienceInside.peptides.subtitle': '"Pametni glasnici, a ne carobna krema"',
  'scienceInside.peptides.point1': 'Kratki lanci aminokiselina koji signaliziraju vasoj kozi da se ponasa poput mlade, obnovljene koze',
  'scienceInside.peptides.point2': 'Podrzavaju cvrsci izgled i manje vidljive bore tijekom vremena',
  'scienceInside.peptides.point3': 'Jacaju kozu barijeru - koza se osjeca manje "krhkom" i manje reaktivnom',
  'scienceInside.peptides.point4': 'Pametan efekt koji se pojacava dosljednom uporabom, a ne cudo od jednog dana',
  'scienceInside.pdrn.title': 'PDRN - obnovitelj',
  'scienceInside.pdrn.subtitle': 'Vodeci sastojak za obnovu u svijetu K-Beauty',
  'scienceInside.pdrn.point1': 'Fragmenti DNA koji govore jezikom obnove i regeneracije',
  'scienceInside.pdrn.point2': 'Podrzava kvalitetu koze i potice zdrav, gust izgled',
  'scienceInside.pdrn.point3': 'Umiruje stresiranu ili reaktivnu kozu - manje crvenila, vise ravnoteze',
  'scienceInside.pdrn.point4': 'U serumu: dosljedno i pametno poboljsanje - ne dramaticno preko noci',
  'scienceInside.combo.title': 'Dva pokretaca, jedan serum',
  'scienceInside.combo.subtitle': 'Trenutni sjaj + kumulativni anti-aging',
  'scienceInside.combo.point1': 'Pokretac 1: "Vidljivo odmah" - hidratacija, rasprsivanje svjetla, glada tekstura',
  'scienceInside.combo.point2': 'Pokretac 2: "Vidljivo s vremenom" - ucvrscivanje, elasticnost, obnova',
  'scienceInside.combo.point3': 'Trenutni "wow" efekt vas motivira da nastavite - peptidi i PDRN rade ostatak',
  'scienceInside.combo.point4': 'Rezultat: koza koja izgleda gusta, smirena i ugladena',
  'scienceInside.tagline': 'Peptidi grade i jacaju. PDRN popravlja i umiruje. Zajedno daju vasoj kozi trenutni sjaj i dugorocnu obnovu.',

  // Science Inside - Default
  'scienceInside.default.subtitle': 'Znanost iza PDRN-a - kako mijenja vasu kozu iznutra',
  'scienceInside.default.tagline': 'PDRN aktivira prirodni mehanizam popravka koze, potice stanicnu regeneraciju i duboku hidrataciju vec od prvog koristenja.',

  // Default product FAQ
  'productContent.default.faq1.q': 'Sto je PDRN i kako djeluje?',
  'productContent.default.faq1.a': 'PDRN (polidezoksiribonukleotid) se dobiva iz DNA lososa. Aktivira prirodni mehanizam popravka koze putem adenozinskog receptora A2A, potice stanicnu regeneraciju, proizvodnju kolagena i duboku hidrataciju.',
  'productContent.default.faq2.q': 'Je li proizvod prikladan za osjetljivu kozu?',
  'productContent.default.faq2.a': 'Da! Nase formule su dermatoloski testirane, bez okrutnosti i bez parabena, sulfata i ftalata. Dizajnirane su da budu njezne za sve tipove koze, ukljucujuci osjetljivu kozu.',
  'productContent.default.faq3.q': 'Koliko dugo treba cekati da se vide rezultati?',
  'productContent.default.faq3.a': 'Vecina korisnica primjecuje poboljsanu hidrataciju i vidljivi sjaj vec od prvog koristenja. Za optimalne rezultate na linijama izraza i teksturi koze, preporucuje se dosljedna uporaba od 4-8 tjedana.',

  // Science Inside - Masks
  'scienceInside.masks.subtitle': 'Kako tri mocna sastojka djeluju zajedno u svakoj platnenoj maski',
  'scienceInside.masks.tagline': 'PDRN popravlja na stanicnoj razini. Vitamin B12 osvjetljuje. Niacinamid jaca. 20 minuta - to je sve sto vasa koza treba da upije sve.',
  'scienceInside.masks.card1.title': 'PDRN + Vitamin B12 - duo za sjaj',
  'scienceInside.masks.card1.subtitle': 'Stanicni popravak susrece vidljivi sjaj',
  'scienceInside.masks.card1.point1': 'PDRN aktivira stanicnu regeneraciju dok vitamin B12 daje trenutni efekt posvjetljivanja',
  'scienceInside.masks.card1.point2': 'Zajedno rjesavaju tuplju kozu u korijenu - ne samo povrsinski sjaj',
  'scienceInside.masks.card1.point3': 'B12 je dokazani sastojak za njegu koze koji ujednacava ten tijekom vremena',
  'scienceInside.masks.card1.point4': 'Duo djeluje sinergijski - PDRN obnavlja, B12 osvjetljuje',
  'scienceInside.masks.card2.title': 'Niacinamid - graditelj barijere',
  'scienceInside.masks.card2.subtitle': 'Jaca, balansira, stiti',
  'scienceInside.masks.card2.point1': 'Jaca koznu barijeru kako bi zakljucao vlagu i sprijecio ulazak iritanata',
  'scienceInside.masks.card2.point2': 'Vidljivo smanjuje pore i regulira visak sebuma',
  'scienceInside.masks.card2.point3': 'Smanjuje crvenilo i umiruje upale - idealan za osjetljivu kozu',
  'scienceInside.masks.card2.point4': 'Djeluje u svim slojevima koze za poboljsanje teksture, tena i otpornosti',
  'scienceInside.masks.card3.title': 'Efekt maske - 20 minuta duboke apsorpcije',
  'scienceInside.masks.card3.subtitle': 'Zasto je platnena maska bolja od obicnog seruma',
  'scienceInside.masks.card3.point1': 'Platnena maska stvara okluzivno okruzenje koje sprjecava isparavanje',
  'scienceInside.masks.card3.point2': 'Aktivni sastojci se isporucuju u vecoj koncentraciji nego u svakodnevnim serumima',
  'scienceInside.masks.card3.point3': 'Duboka apsorpcija - sastojci prodiru dublje zahvaljujuci produzenom kontaktu s kozom',
  'scienceInside.masks.card3.point4': 'Trenutni i vidljivi rezultati: punija, hidratiziranija i sjajnija koza vec nakon jednog koristenja',

  // Science Inside - Cream
  'scienceInside.cream.subtitle': 'Tri napredne tehnologije koje rade nocu kako bi transformirale vasu kozu',
  'scienceInside.cream.tagline': 'Kolagen obnavlja strukturu. Ceramidi stite barijeru. Pametne kapsule isporucuju sve tijekom noci - da se probudite s obnovljenom i cvrstom kozom.',
  'scienceInside.cream.card1.title': 'Hidrolizirani kolagen - struktura',
  'scienceInside.cream.card1.subtitle': 'Obnova iznutra prema van',
  'scienceInside.cream.card1.point1': 'Razbijen na male fragmente koji zaista mogu prodrijeti u kozu - ne samo sjediti na povrsini',
  'scienceInside.cream.card1.point2': 'Podrzava strukturnu matricu koze za poboljsanu cvrstocu i elasticnost',
  'scienceInside.cream.card1.point3': 'Pomaze smanjiti izgled finih linija popunjavanjem iznutra',
  'scienceInside.cream.card1.point4': 'Radi s prirodnom proizvodnjom kolagena vase koze - jacanje, ne zamjena',
  'scienceInside.cream.card2.title': 'Ceramidni kompleks - stit',
  'scienceInside.cream.card2.subtitle': 'Prirodna zastita vase koze, ojacana',
  'scienceInside.cream.card2.point1': 'Ceramidi cine 50% prirodne kozne barijere - nadopunjujemo ono sto se gubi starenjem',
  'scienceInside.cream.card2.point2': 'Zakljucava vlagu do 72 sata - vise nema osjecaja suhoce i zategnutosti nocu',
  'scienceInside.cream.card2.point3': 'Stiti od okolisnog ostecenja: zagadenje, suhi zrak, temperaturne promjene',
  'scienceInside.cream.card2.point4': 'Jaca barijeru kako bi drugi aktivni sastojci djelovali ucinkovitije',
  'scienceInside.cream.card3.title': 'Tehnologija pametnih kapsula - postupno oslobadanje',
  'scienceInside.cream.card3.subtitle': 'Aktivni sastojci se isporucuju cijelu noc',
  'scienceInside.cream.card3.point1': 'Mikrokapsule se postupno raspadaju i oslobadaju aktivne sastojke tijekom 8 sati',
  'scienceInside.cream.card3.point2': 'Sprjecava razgradnju sastojaka - ostaju jaki do trenutka oslobadanja',
  'scienceInside.cream.card3.point3': 'Vasa koza dobiva stalan dotok hranjivosti umjesto jedne velike doze koja nestaje',
  'scienceInside.cream.card3.point4': 'Probudite se s obnovljenom i hidratiziranom kozom - kapsule su radile dok ste spavali',

  // Science Inside - Bundle
  'scienceInside.bundle.subtitle': 'Zasto tri proizvoda zajedno daju rezultate koje nijedan pojedinacni proizvod ne moze',
  'scienceInside.bundle.tagline': 'Maske ciste i hrane. Serum popravlja i osvjetljuje. Krema zakljucava sve unutra. Tri koraka, jedan sustav - 24 sata kontinuirane transformacije koze.',
  'scienceInside.bundle.card1.title': 'Tri koraka, jedan sustav',
  'scienceInside.bundle.card1.subtitle': 'Svaki proizvod priprema kozu za sljedeci korak',
  'scienceInside.bundle.card1.point1': 'Korak 1: Platnene maske dubinski ciste i hrane koncentriranim PDRN-om + vitaminom B12',
  'scienceInside.bundle.card1.point2': 'Korak 2: Serum popravlja, ucvrscuje i daje Glass Skin efekt',
  'scienceInside.bundle.card1.point3': 'Korak 3: Krema zakljucava sve s kolagenom, ceramidima i kapsulama s postupnim oslobadanjem',
  'scienceInside.bundle.card1.point4': 'Zajedno: potpuna rutina u kojoj svaki korak pojacava prethodni',
  'scienceInside.bundle.card2.title': 'Efekt sinergije - bolje zajedno',
  'scienceInside.bundle.card2.subtitle': 'Kumulativni rezultati koji jacaju s vremenom',
  'scienceInside.bundle.card2.point1': 'Koristenje sva tri proizvoda stvara kumulativni efekt - rezultati se nadograduju jedni na druge',
  'scienceInside.bundle.card2.point2': 'PDRN u svakom koraku znaci dosljednu stanicnu regeneraciju kroz cijelu rutinu',
  'scienceInside.bundle.card2.point3': 'Razliciti nacini primjene (maska, serum, krema) osiguravaju da sastojci dosegnu sve slojeve koze',
  'scienceInside.bundle.card2.point4': 'Kupci izvjestavaju o znatno brzim rezultatima s potpunom rutinom',
  'scienceInside.bundle.card3.title': '24-satna pokrivenost - dan i noc',
  'scienceInside.bundle.card3.subtitle': 'Vasa koza nikada nije bez zastite',
  'scienceInside.bundle.card3.point1': 'Jutro: Serum ispod sminke za hidrataciju, zastitu i sjaj cijeli dan',
  'scienceInside.bundle.card3.point2': 'Vecer: Platnena maska za dubinsko ciscenje i hranjenje (2-3 puta tjedno)',
  'scienceInside.bundle.card3.point3': 'Noc: Krema s kapsulama postupnog oslobadanja koje rade dok spavate',
  'scienceInside.bundle.card3.point4': 'Rezultat: Obnova nonstop - vasa koza se poboljsava 24/7',

  // What is PDRN
  'whatIsPDRN.title': 'Sto je PDRN?',
  'whatIsPDRN.subtitle': 'Revolucionarni sastojak koji mijenja svijet njege koze - iz klinike u vas dom',
  'whatIsPDRN.origin.title': 'Dobiven iz DNA lososa',
  'whatIsPDRN.origin.subtitle': 'Dokazani sastojak u estetskoj medicini',
  'whatIsPDRN.origin.point1': 'PDRN (polidezoksiribonukleotid) se dobiva iz DNA lososa - biokompatibilna molekula koja se koristi u dermatoloskim klinikama sirom svijeta',
  'whatIsPDRN.origin.point1.US': 'PDRN (polidezoksiribonukleotid) se dobiva iz DNA lososa - biokompatibilna molekula koja se koristi u dermatoloskim klinikama sirom SAD-a',
  'whatIsPDRN.origin.point1.GB': 'PDRN (polidezoksiribonukleotid) se dobiva iz DNA lososa - biokompatibilna molekula koja se koristi u dermatoloskim klinikama sirom Ujedinjenog Kraljevstva',
  'whatIsPDRN.origin.point1.AU': 'PDRN (polidezoksiribonukleotid) se dobiva iz DNA lososa - biokompatibilna molekula koja se koristi u dermatoloskim klinikama sirom Australije',
  'whatIsPDRN.origin.point1.IL': 'PDRN (polidezoksiribonukleotid) se dobiva iz DNA lososa - biokompatibilna molekula koja se koristi u dermatoloskim klinikama sirom Izraela',
  'whatIsPDRN.origin.point1.HR': 'PDRN (polidezoksiribonukleotid) se dobiva iz DNA lososa - biokompatibilna molekula koja se koristi u dermatoloskim klinikama sirom Hrvatske',
  'whatIsPDRN.origin.point1.FR': 'PDRN (polidezoksiribonukleotid) se dobiva iz DNA lososa - biokompatibilna molekula koja se koristi u dermatoloskim klinikama sirom Francuske',
  'whatIsPDRN.origin.point1.DE': 'PDRN (polidezoksiribonukleotid) se dobiva iz DNA lososa - biokompatibilna molekula koja se koristi u dermatoloskim klinikama sirom Njemacke',
  'whatIsPDRN.origin.point1.ES': 'PDRN (polidezoksiribonukleotid) se dobiva iz DNA lososa - biokompatibilna molekula koja se koristi u dermatoloskim klinikama sirom Spanjolske',
  'whatIsPDRN.origin.point1.NO': 'PDRN (polidezoksiribonukleotid) se dobiva iz DNA lososa - biokompatibilna molekula koja se koristi u dermatoloskim klinikama sirom Norveske',
  'whatIsPDRN.origin.point1.FI': 'PDRN (polidezoksiribonukleotid) se dobiva iz DNA lososa - biokompatibilna molekula koja se koristi u dermatoloskim klinikama sirom Finske',
  'whatIsPDRN.origin.point1.AE': 'PDRN (polidezoksiribonukleotid) se dobiva iz DNA lososa - biokompatibilna molekula koja se koristi u dermatoloskim klinikama sirom Ujedinjenih Arapskih Emirata',
  'whatIsPDRN.origin.point2': 'Potkrijepljen klinickim istrazivanjima s mjerljivim rezultatima u hidrataciji i elasticnosti',
  'whatIsPDRN.origin.point3': 'Prirodni regenerativni spoj - bez sintetickih punila, bez agresivnih kemikalija',
  'whatIsPDRN.howItWorks.title': 'Regeneracija na stanicnoj razini',
  'whatIsPDRN.howItWorks.subtitle': 'Djeluje tamo gdje drugi proizvodi ne dopiru',
  'whatIsPDRN.howItWorks.point1': 'Aktivira adenozinski receptor A2A - potice prirodni proces popravka i obnove vase koze',
  'whatIsPDRN.howItWorks.point2': 'Potice proizvodnju kolagena i elastina iznutra, a ne samo povrsinski hidrira',
  'whatIsPDRN.howItWorks.point3': 'Smanjuje upale i umiruje stresiranu kozu za zdraviju i uravnotezeniju kozu',
  'whatIsPDRN.results.title': 'Klinicki rezultati kod kuce',
  'whatIsPDRN.results.subtitle': 'Do nedavno - samo u klinikama',
  'whatIsPDRN.results.point1': 'Do nedavno su PDRN tretmani bili dostupni samo u luksuznim dermatoloskim klinikama po visokim cijenama',
  'whatIsPDRN.results.point2': 'Nase formule isporucuju isti aktivni sastojak u formatu za svakodnevnu uporabu koji mozete nanijeti kod kuce',
  'whatIsPDRN.results.point3': '+100% poboljsanje hidratacije klinicki izmjereno - vidljivo poboljsanje vec od prvog nanosenja',

  // Proven Results
  'provenResults.title': 'Dokazani rezultati',
  'provenResults.stat1.value': '+100%',
  'provenResults.stat1.label': 'Poboljsanje hidratacije',
  'provenResults.stat1.sub': 'Klinicki izmjereno',
  'provenResults.stat2.value': '93%',
  'provenResults.stat2.label': 'Gladja koza',
  'provenResults.stat2.sub': 'Prijavljeno unutar 4 tjedna',
  'provenResults.stat3.value': '4.9/5',
  'provenResults.stat3.label': 'Ocjena kupaca',
  'provenResults.stat3.sub': 'Prosjek svih proizvoda',
  'provenResults.stat4.value': '+10.000',
  'provenResults.stat4.label': 'Zadovoljnih kupaca',
  'provenResults.stat4.sub': 'Sirom svijeta',
  'provenResults.stat4.sub.US': 'Sirom SAD-a',
  'provenResults.stat4.sub.GB': 'Sirom Ujedinjenog Kraljevstva',
  'provenResults.stat4.sub.AU': 'Sirom Australije',
  'provenResults.stat4.sub.IL': 'Sirom Izraela',
  'provenResults.stat4.sub.HR': 'Sirom Hrvatske',
  'provenResults.stat4.sub.FR': 'Sirom Francuske',
  'provenResults.stat4.sub.DE': 'Sirom Njemacke',
  'provenResults.stat4.sub.ES': 'Sirom Spanjolske',
  'provenResults.stat4.sub.NO': 'Sirom Norveske',
  'provenResults.stat4.sub.FI': 'Sirom Finske',
  'provenResults.stat4.sub.AE': 'Sirom Ujedinjenih Arapskih Emirata',

  // Comparison Table
  'comparison.title': 'PDRN naspram obicne njege',
  'comparison.headerRegular': 'Obicna njega',
  'comparison.headerPDRN': 'PDRN SKIN',
  'comparison.row1.criteria': 'Djelovanje',
  'comparison.row1.regular': 'Povrsinska hidratacija',
  'comparison.row1.pdrn': 'Regeneracija na stanicnoj razini',
  'comparison.row2.criteria': 'Aktivni sastojak',
  'comparison.row2.regular': 'Genericki peptidi',
  'comparison.row2.pdrn': 'PDRN (DNA lososa)',
  'comparison.row3.criteria': 'Rezultati',
  'comparison.row3.regular': 'Tjednima do vidljivih rezultata',
  'comparison.row3.pdrn': 'Vidljivo vec od prvog koristenja',
  'comparison.row4.criteria': 'Tehnologija',
  'comparison.row4.regular': 'Standardne formule',
  'comparison.row4.pdrn': 'Tehnologija klinicke razine',
  'comparison.row5.criteria': 'Klinicki dokazi',
  'comparison.row5.regular': 'Marketinske tvrdnje',
  'comparison.row5.pdrn': 'Klinicki testirano +100% hidratacija',

  // FAQ
  'faq.sectionTitle': 'Cesta pitanja',

  // 404
  '404.title': 'Stranica nije pronadena',
  '404.subtitle': 'Stranica koju trazite ne postoji ili je premjestena.',
  '404.backHome': 'Povratak na naslovnicu',
  '404.popularProducts': 'Popularni proizvodi',

  // Product disclaimer and extras
  'product.disclaimer': '*Slike su samo ilustrativne. Rezultati se mogu razlikovati od osobe do osobe ovisno o tipu koze i nacinu koristenja. Proizvod nije namijenjen dijagnosticiranju, lijecenju ili sprecavanju medicinskih stanja. Preporucuje se provesti test osjetljivosti na skrivenom podrucju prije prve potpune uporabe. U slucaju osjetljivosti, prestanite s uporabom. U slucaju ozbiljne osjetljivosti, obratite se lijecniku. Dobavljac moze s vremena na vrijeme promijeniti ambalazu i oblik proizvoda; radi se o istom proizvodu.',
  'product.shippingMarquee': 'Besplatna dostava za narudzbe iznad {amount} u Hrvatskoj',
  'product.inStockReady': 'Na zalihi - spremno za isporuku',

  // Terms agreement
  'product.termsAgreementBefore': 'Pregledavanjem i kupovinom na ovoj stranici pristajete na',
  'product.termsLink': 'Uvjete koristenja',
  'product.termsAgreementAfter': 'stranice',

  // Announcement
  'announcement.freeShipping': '\u2728 besplatna dostava za narudzbe iznad {amount} u Hrvatskoj',
  'announcement.close': 'Zatvori',

  // Urgency
  'urgency.limitedOffer': 'Ogranicena ponuda',
  'urgency.endsIn': 'Zavrsava za',

  // Blog
  'blog.title': 'Blog',
  'blog.subtitle': 'Profesionalni vodicci za njegu koze, PDRN znanost i savjeti iz korejske njege',
  'blog.metaDescription': 'Procitajte nase profesionalne vodice o PDRN njezi, znanosti DNA lososa, Glass Skin rutinama i savjetima iz korejske njege koze.',
  'blog.readMore': 'Procitajte vise',
  'blog.minRead': 'min citanja',
  'blog.badge': 'Znanstveno dokazana njega',
  'blog.chip.antiAging': 'Anti-aging',
  'blog.chip.hydration': 'Hidratacija',
  'blog.chip.sensitiveSkin': 'Osjetljiva koža',
  'blog.chip.nightRoutine': 'Noćna rutina',
  'blog.chip.ingredients': 'Sastojci',
  'blog.chip.layering': 'Layering',
  'blog.chip.glassSkin': 'Glass Skin',
  'blog.chip.pdrnScience': 'PDRN znanost',
  'blog.relatedArticles': 'Povezani clanci',
  'blog.recommendedProducts': 'Preporuceni proizvodi',
  'blog.latestArticles': 'Najnovije na nasem blogu',
  'blog.latestSubtitle': 'Profesionalni vodicci za PDRN njegu i savjeti iz korejske njege koze',
  'blog.viewAll': 'Svi clanci',
  'blog.statsArticles': 'Clanaka',
  'blog.statsLanguages': 'Jezika',
  'blog.statsVersions': 'Prevedenih verzija',
  'blog.availableIn': 'Dostupno na 11 jezika',
  'blog.avgReadTime': 'Prosj. 5 min citanja',

  // SEO meta (homepage)
  'seo.homeTitle': 'PDRN Njega Koze | Korejski Serum s DNA Lososa, Maske & Krema | Glass Skin',
  'seo.homeDescription': 'PDRN njega koze s korejskom DNA lososa tehnologijom. PDRN serum, platnene maske i kapsulirana krema za Glass Skin efekt. Klinički dokazano s besplatnom dostavom.',

  // SEO product titles & descriptions
  'seo.productTitle.pink-glow-serum-with-pdrn-peptides': 'PDRN Serum s DNA Lososa i Peptidima | PDRN Njega Koze',
  'seo.productDescription.pink-glow-serum-with-pdrn-peptides': 'Kupite PDRN serum s DNA lososa i peptidima. Korejski Glass Skin serum koji potiče kolagen i izglađuje bore. PDRN njega koze s besplatnom dostavom.',
  'seo.productTitle.pdrn-pink-sheet-masks-10-pack': 'PDRN Platnene Maske 10 komada | Korejske DNA Lososa Maske | PDRN Njega',
  'seo.productDescription.pdrn-pink-sheet-masks-10-pack': 'Kupite PDRN platnene maske natopljene serumom DNA lososa. 10 korejskih maski za lice za Glass Skin efekt s PDRN, Vitaminom B12 i Niacinamidom.',
  'seo.productTitle.smart-capsule-cream-with-collagen': 'PDRN Kapsulirana Krema s Kolagenom | Korejska Njega | PDRN Njega Koze',
  'seo.productDescription.smart-capsule-cream-with-collagen': 'Kupite PDRN kapsuliranu kremu s kolagenom i niacinamidom. Korejska anti-aging krema s DNA lososa tehnologijom za duboku hidrataciju i čvrstoću.',
  'seo.productTitle.complete-pdrn-trio-bundle': 'Kompletni PDRN Set — Serum, Maske & Krema | PDRN Njega Koze',
  'seo.productDescription.complete-pdrn-trio-bundle': 'Kupite kompletni PDRN set za njegu koze sa serumom, 10 maski i kremom. Uštedite do 53% na korejskoj DNA lososa njezi.',

  // Internal linking
  'seo.explorePDRN': 'Otkrijte PDRN njegu koze',
  'seo.anchor.serumBenefits': 'Prednosti PDRN seruma',
  'seo.anchor.howPDRNWorks': 'Kako PDRN djeluje',
  'seo.anchor.masksVsTraditional': 'PDRN maske vs. tradicionalne',
  'seo.anchor.glassSkinGuide': 'Glass Skin vodič',
  'seo.anchor.koreanSecret': 'Korejska tajna njege',
  'seo.anchor.pdrnVsRegular': 'PDRN vs. obična njega',
};
